import YGCClassPage from "./YGCClassPage";

const MEMBERS = [
  {
    name: "Ravi Gadhirau",
    image: "/images/ygc/2026/Ravi.png",
    bio: "Ravi Gadhiraju is an eighth grader moving from Kingsley Junior High to his freshman year at NCHS. Originally from Decatur, he has lived in Bloomington since he was very young. He enjoys robotics club, running, and watching football.",
    quote: "Go with the flow."
  },
  {
    name: "Anjali Vytla",
    image: "/images/ygc/2026/Anjal.png",
    bio: "Anjali Vytla is an incoming freshman at Normal Community High School. She is enthusiastic about robotics and research, hopes to pursue a career in medicine, and enjoys tennis, drawing, and community outreach.",
    quote: "We cannot solve our problems with the same thinking we used when we created them — Albert Einstein"
  },
  {
    name: "Kavin Sivagnanam",
    image: "/images/ygc/2026/Kavin.png",
    bio: "Kavin Sivagnanam is an incoming freshman at U-High who enjoys running, math, and spending time with friends. He is hardworking, motivated, and strives to inspire others while making a positive impact in his community.",
    quote: "Some people want it to happen, some wish it would happen, others make it happen. — Michael Jordan"
  },
  {
    name: "Aubriella Snelling",
    image: "/images/ygc/2026/Aubriella.png",
    bio: "Aubriella Snelling is a senior at NCHS with aspirations in politics. She is a dedicated basketball player, long-time dancer, and passionate volunteer who enjoys working with diverse groups and learning about history.",
    quote: "All men’s souls are immortal, but the souls of the righteous are immortal and divine. — Plato"
  },
  {
    name: "Anuraag Kadiyala",
    image: "/images/ygc/2026/Anuraag.png",
    bio: "Anuraag Kadiyala is a rising sophomore at U-High with strong interests in robotics, engineering, and technology. He has participated in FLL, FTC, and now FRC, and enjoys CAD design, Arduino projects, soccer, taekwondo, jujitsu, speech, debate, and FBLA.",
    quote: "Our greatest glory is not in never falling, but in rising every time we fall. — Confucius"
  },
  {
    name: "Arjun Vyas",
    image: "/images/ygc/2026/Arjun.png",
    bio: "Arjun Vyas is a hardworking student who enjoys learning, especially in math, science, and technology. He hopes to challenge himself academically, build teamwork skills, and pursue a career that positively impacts his community.",
    quote: "I've failed over and over and over again in my life. And that is why I succeed. — Michael Jordan"
  },
  {
    name: "Amulya Kadiyala",
    image: "/images/ygc/2026/Amulya.png",
    bio: "Amulya Kadiyala is a sophomore at U-High interested in biomedical engineering, robotics, AI, and research. She is involved in FBLA, Robotics, and student leadership, and enjoys creating technology-based solutions and participating in STEM outreach.",
    quote: "Do the best you can until you know better. Then, when you know better, do better. — Maya Angelou"
  },
  {
    name: "Srinidhi Goli",
    image: "/images/ygc/2026/Srinidhi.png",
    bio: "Srinidhi Goli is an incoming freshman who enjoys drawing, crocheting, dancing, and spending time with loved ones. She is excited for new opportunities, hopes to pursue a medical career, and is grateful for her support system.",
    quote: "Always dream big, stay humble, and never forget what you're worth. All the little steps you take today is the person you'll become tomorrow."
  },
  {
    name: "Jhanavi Paidi",
    image: "/images/ygc/2026/Jhanavi.png",
    bio: "Jhanavi Paidi is an incoming freshman at NCHS who enjoys dancing, spending time with friends, and trying new experiences. She hopes to pursue a career in the medical field and is excited to make lasting memories.",
    quote: "Everything happens for a reason, and every experience helps shape who you’re meant to be. — Unknown"
  },
  {
    name: "Haasini Konakanchi",
    image: "/images/ygc/2026/Haasini.png",
    bio: "Haasini Konakanchi is an incoming freshman at NCHS with a passion for helping the community and making a positive difference. She is compassionate, empathetic, and excited to see what she can accomplish in the future.",
    quote: "You only fail when you stop trying. — Thomas Edison"
  },
  {
    name: "Sahith Poondru",
    image: "/images/ygc/2026/Sahith.png",
    bio: "Sahith Poondru is an incoming freshman at NCHS driven by curiosity, discipline, and purposeful leadership. He enjoys robotics, mentoring, writing, and basketball, and hopes to inspire others through bold thinking and meaningful impact.",
    quote: "The only thing standing between you and your goal is the story you keep telling yourself. — Jordan Belfort"
  },
  {
    name: "Shloka Chebolu",
    image: "/images/ygc/2026/Shloka.png",
    bio: "Shloka Chebolu is an incoming sophomore at NCHS passionate about science and hopes to become a dermatologist or pediatrician. She has volunteered at Carle BroMenn Hospital and enjoys Indian classical music and singing.",
    quote: "If you have the power to make someone happy, do it. The world needs more of that. — Unknown"
  },
  {
    name: "Shruthika Geejula",
    image: "/images/ygc/2026/Shruthika.png",
    bio: "Shruthika Geejula is an incoming freshman at NCHS. She is creative, hardworking, and passionate about reading, drawing, singing, math, and science. She hopes to pursue a medical career.",
    quote: "Success comes from curiosity, concentration, perseverance, and self-criticism. — Albert Einstein"
  },
  {
    name: "Vanshika Bandaru",
    image: "/images/ygc/2026/Vanshika.png",
    bio: "Vanshika Bandaru is a rising sophomore leader in YGC 2026 and an alumna of Lt. Governor Juliana Stratton's Girls Lead Program. She enjoys tennis, swimming, chess, dance, robotics, and piano, and looks forward to collaborating with nonprofits to make a lasting impact.",
    quote: "Success isn't about never failing. It's about learning, adapting, and getting back up when you fall."
  },
  {
    name: "Harini Manikandan",
    image: "/images/ygc/2026/Harini.png",
    bio: "Harini Manikandan is an incoming freshman at NCHS who loves violin, crocheting, classical dance, singing, and science. She values family time and hopes to pursue a career in science.",
    quote: "Time together as a family is a gift. — Joanna Gaines"
  },
  {
    name: "Annika (Annie) George",
    image: "/images/ygc/2026/Annie.png",
    bio: "Annie George is a senior at U-High passionate about leadership, service, and community involvement. She leads multiple clubs, is a nationally competitive dancer, and enjoys volunteering and inspiring others.",
    quote: "The only thing more powerful than hate is love."
  },
  {
    name: "Tanish Nagireddy",
    image: "/images/ygc/2026/Tanish.png",
    bio: "Tanish is a rising sophomore at NCHS interested in biology, chemistry, and engineering. He is involved in FBLA, HOSA, and Math Team, volunteers at the Children's Discovery Museum, and hopes to pursue a medical career.",
    quote: "A society grows great when old men plant trees in whose shade they know they shall never sit."
  },
  {
    name: "Ananya Agrawal",
    image: "/images/ygc/2026/Ananya.png",
    bio: "Ananya Agrawal is a driven sophomore at NCHS who balances academics with piano, dance, swimming, and sketching. She hopes to pursue a career in medicine and enjoys spending time with family and friends.",
    quote: "People will forget what you said, people will forget what you did, but people will never forget how you made them feel. — Maya Angelou"
  },
  {
    name: "Rayan Kondaveeti",
    image: "/images/ygc/2026/Rayan.png",
    bio: "Rayan is a caring and responsible individual who values kindness, learning, and meaningful relationships. They look forward to continuing to grow, serve others, and embrace new opportunities.",
    quote: "I look forward to seeing what the future holds, knowing that each new day helps shape the path ahead."
  },
  {
    name: "Sidak Bindra",
    image: "/images/ygc/2026/Sidak.png",
    bio: "Sidak Bindra is a sophomore at NCHS passionate about biology and helping others. She enjoys reading, swimming, and volunteering, and hopes to become a pediatrician who makes a positive impact.",
    quote: "The best way to find yourself is to lose yourself in the service of others. — Mahatma Gandhi"
  }
];


export default function Ygc2026() {
  return (
    <YGCClassPage
      year="2026"
      logoSrc="/images/ygc/2026/YGC_2026.png"
      photos={[{ src: "/images/ygc/2026/YGC2026.png", caption: "Students from For A Better Tomorrow's summer youth leadership program — Youth Global Citizen (YGC) Class of 2026" }]}
      members={MEMBERS}
    />
  );
}